import { Link } from 'react-router-dom';
import styles from 'Styles/StartButton.module.css'
import useDelayedNavigate from 'Hooks/useDelayedNavigate';

export const StartButton = ({
	label,
	linkTarget,
	btnClick = () => {}
}) => {
	const {delayedNavigate} = useDelayedNavigate();

	return (
		<button className={styles.startButton}>


			<Link onClick={(e)=>{
				e.preventDefault();
				if (btnClick) btnClick();
				delayedNavigate(linkTarget, 300);

			}} to={linkTarget} className={styles.startButtonLink}>
				{label}
				<div className={styles.startButtonDecors}>
				<div className={styles.startButtonArrow}></div>
				<div className={styles.startButtonBorderCircle}></div>
				<div className={styles.startButtonMaskCircle}>
					<div className={styles.startButtonSmallCircle}></div>
				</div>
			</div>
			</Link>

		
		</button>        
	)
}